var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 591.32471 583.3335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c6c6c6;\n      }\n\n      .cls-2 {\n        fill: #7c7c7c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M581.31641,512.332a24.99854,24.99854,0,0,1-17.67676-42.67578L631.2959,402l-67.65625-67.65625a24.99923,24.99923,0,1,1,35.35449-35.354l85.333,85.333a24.9962,24.9962,0,0,1,0,35.354l-85.333,85.334A24.92356,24.92356,0,0,1,581.31641,512.332Z",
    transform: "translate(-100.32568 -108.3335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M664.32617,426.98633h-339a25,25,0,0,1,0-50h339a25,25,0,0,1,0,50Z",
    transform: "translate(-100.32568 -108.3335)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dark",
    className: "cls-2",
    d: "M391.99268,691.667c-79.96045,0-153.04786-27.5957-205.80225-77.707a266.12283,266.12283,0,0,1-63.03955-92.47461c-15.146-36.8418-22.8252-77.71484-22.8252-121.48535,0-43.771,7.6792-84.64355,22.8252-121.48535a266.10356,266.10356,0,0,1,63.03955-92.47315c52.75439-50.11035,125.8418-77.708,205.80225-77.708a25,25,0,0,1,0,50c-67.08789,0-127.9458,22.71435-171.36475,63.958C174.63623,265.98145,150.32568,327.43115,150.32568,400c0,72.56836,24.31055,134.02051,70.30225,177.708,43.41895,41.24414,104.27686,63.959,171.36475,63.959a25,25,0,0,1,0,50Z",
    transform: "translate(-100.32568 -108.3335)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2383f992.svg";
export { ForwardRef as ReactComponent };